import {
  FETCH_CLIENT_DATA,
  FETCH_CLIENT_DATA_FAIL,
  FETCH_CLIENT_DATA_SUCCESS,
  UPDATE_CLIENT_DATA,
  IClientData,
  IError,
  IFetchClientDataPayload,
} from '.'
import { ActionResponse } from '../../interfaces'

export const fetchClientData = (payload: IFetchClientDataPayload): ActionResponse<IFetchClientDataPayload> => ({
  type: FETCH_CLIENT_DATA,
  payload,
})

export const fetchClientDataSuccess = (payload: IClientData): ActionResponse<IClientData> => ({
  type: FETCH_CLIENT_DATA_SUCCESS,
  payload,
})

export const fetchClientDataFail = (payload: IError): ActionResponse<IError> => ({
  type: FETCH_CLIENT_DATA_FAIL,
  payload,
})

export const updateClientData = (payload: IClientData): ActionResponse<IClientData> => ({
  type: UPDATE_CLIENT_DATA,
  payload,
})
